//to add Customers

export const ADD_CUSTOMER_START = "ADD_CUSTOMER_START"
export const ADD_CUSTOMER_SUCCESS = "ADD_CUSTOMER_SUCCESS"
export const ADD_CUSTOMER_FAILURE = "ADD_CUSTOMER_FAILURE"
export const ADD_CUSTOMER_RESET = "ADD_CUSTOMER_RESET"

// to get Customers

export const GET_CUSTOMER_START = "GET_CUSTOMER_START"
export const GET_CUSTOMER_SUCCESS = "GET_CUSTOMER_SUCCESS"
export const GET_CUSTOMER_FAILURE = "GET_CUSTOMER_FAILURE"
export const GET_CUSTOMER_RESET = "GET_CUSTOMER_RESET"

// to Edit Customers

export const EDIT_CUSTOMER_START = "EDIT_CUSTOMER_START"
export const EDIT_CUSTOMER_SUCCESS = "EDIT_CUSTOMER_SUCCESS"
export const EDIT_CUSTOMER_FAILURE = "EDIT_CUSTOMER_FAILURE"
export const EDIT_CUSTOMER_RESET = "EDIT_CUSTOMER_RESET"

// to delete Customers

export const DELETE_CUSTOMER_START = "DELETE_CUSTOMER_START"
export const DELETE_CUSTOMER_SUCCESS = "DELETE_CUSTOMER_SUCCESS"
export const DELETE_CUSTOMER_FAILURE = "DELETE_CUSTOMER_FAILURE"
export const DELETE_CUSTOMER_RESET = "DELETE_CUSTOMER_RESET"

// view-customer

export const VIEW_CUSTOMER_START = "VIEW_CUSTOMER_START"
export const VIEW_CUSTOMER_SUCCESS = "VIEW_CUSTOMER_SUCCESS"
export const VIEW_CUSTOMER_FAILURE = "VIEW_CUSTOMER_FAILURE"
export const VIEW_CUSTOMER_RESET = "VIEW_CUSTOMER_RESET"

// Customer Type
export const GET_CUSTOMER_TYPE_START = "GET_CUSTOMER_TYPE_START"
export const GET_CUSTOMER_TYPE_SUCCESS = "GET_CUSTOMER_TYPE_SUCCESS"
export const GET_CUSTOMER_TYPE_FAILURE = "GET_CUSTOMER_TYPE_FAILURE"
export const GET_CUSTOMER_TYPE_RESET = "GET_CUSTOMER_TYPE_RESET"

// ADD CUSTOMR FOLLOWUPS
export const ADD_CUSTOMER_FOLLOWUP_START = "ADD_CUSTOMER_FOLLOWUP_START"
export const ADD_CUSTOMER_FOLLOWUP_SUCCESS = "ADD_CUSTOMER_FOLLOWUP_SUCCESS"
export const ADD_CUSTOMER_FOLLOWUP_FAILURE = "ADD_CUSTOMER_FOLLOWUP_FAILURE"
export const ADD_CUSTOMER_FOLLOWUP_RESET = "ADD_CUSTOMER_FOLLOWUP_RESET"

// GET CUSTOMR FOLLOWUPS
export const GET_CUSTOMER_FOLLOWUP_START = "GET_CUSTOMER_FOLLOWUP_START"
export const GET_CUSTOMER_FOLLOWUP_SUCCESS = "GET_CUSTOMER_FOLLOWUP_SUCCESS"
export const GET_CUSTOMER_FOLLOWUP_FAILURE = "GET_CUSTOMER_FOLLOWUP_FAILURE"
export const GET_CUSTOMER_FOLLOWUP_RESET = "GET_CUSTOMER_FOLLOWUP_RESET"

// GET CUSTOMER PROFILE
export const GET_CUSTOMER_PROFILE_START = "GET_CUSTOMER_PROFILE_START"
export const GET_CUSTOMER_PROFILE_SUCCESS = "GET_CUSTOMER_PROFILE_SUCCESS"
export const GET_CUSTOMER_PROFILE_FAILURE = "GET_CUSTOMER_PROFILE_FAILURE"
export const GET_CUSTOMER_PROFILE_RESET = "GET_CUSTOMER_PROFILE_RESET"

// UPDATE CUSTOMER PROFILE
export const UPDATE_CUSTOMER_PROFILE_START = "UPDATE_CUSTOMER_PROFILE_START"
export const UPDATE_CUSTOMER_PROFILE_SUCCESS = "UPDATE_CUSTOMER_PROFILE_SUCCESS"
export const UPDATE_CUSTOMER_PROFILE_FAILURE = "UPDATE_CUSTOMER_PROFILE_FAILURE"
export const UPDATE_CUSTOMER_PROFILE_RESET = "UPDATE_CUSTOMER_PROFILE_RESET"

//
export const CUSTOMER_ID_RESET = "CUSTOMER_ID_RESET"

export const GET_CUSTOMER_NAME_START = "GET_CUSTOMER_NAME_START"
export const GET_CUSTOMER_NAME_SUCCESS = "GET_CUSTOMER_NAME_SUCCESS"
export const GET_CUSTOMER_NAME_FAILURE = "GET_CUSTOMER_NAME_FAILURE"
export const GET_CUSTOMER_NAME_RESET = "GET_CUSTOMER_NAME_RESET"

export const UPLOAD_FILE_START = "UPLOAD_FILE_START"
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS"
export const UPLOAD_FILE_FAIL = "UPLOAD_FILE_FAIL"

export const GET_UPLOADED_FILE_START = "GET_UPLOADED_FILE_START"
export const GET_UPLOADED_FILE_SUCCESS = "GET_UPLOADED_FILE_SUCCESS"
export const GET_UPLOADED_FILE_FAILURE = "GET_UPLOADED_FILE_FAILURE"
export const GET_UPLOADED_FILE_RESET = "GET_UPLOADED_FILE_RESET"

export const CREATE_UPLOAD_LINK_START = "CREATE_UPLOAD_LINK_START"
export const CREATE_UPLOAD_LINK_SUCCESS = "CREATE_UPLOAD_LINK_SUCCESS"
export const CREATE_UPLOAD_LINK_FAIL = "CREATE_UPLOAD_LINK_FAIL"

export const UPOLOAD_FILE_LINK_START = "UPOLOAD_FILE_LINK_START"
export const UPOLOAD_FILE_LINK_SUCCESS = "UPOLOAD_FILE_LINK_SUCCESS"
export const UPOLOAD_FILE_LINK_FALSE = "UPOLOAD_FILE_LINK_FALSE"

export const CUST_VIEWFILE_START = "CUST_VIEWFILE_START"
export const CUST_VIEWFILE_SUCCESS = "CUST_VIEWFILE_SUCCESS"
export const CUST_VIEWFILE_FAIL = "CUST_VIEWFILE_FAIL"

export const DELETE_FILE_START = "DELETE_FILE_START"
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS"
export const DELETE_FILE_FAILURE = "DELETE_FILE_FAILURE"
export const DELETE_FILE_RESET = "DELETE_FILE_RESET"

export const EDIT_CUST_FILES = "EDIT_CUST_FILES"
export const EDIT_CUST_FILES_SUCCESS = "EDIT_CUST_FILES_SUCCESS"
export const EDIT_CUST_FILES_FAILED = "EDIT_CUST_FILES_FAILED"


export const GET_BLOCKED_CUST = "GET_BLOCKED_CUST"
export const GET_BLOCKED_CUST_SUCCESS = "GET_BLOCKED_CUST_SUCCESS"
export const GET_BLOCKED_CUST_FAILED = "GET_BLOCKED_CUST_FAILED"
